(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fh-card-colors"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fh-card-colors')) {
    customElements.define('fh-card-colors', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.querySelectorAll('[data-card-variant-id]').forEach(choice => {
          const input = choice.querySelector('input[type="radio"]');
          if (!input) return;
          if (!input.hasAttribute('data-variant-id')) input.dataset.variantId = choice.dataset.cardVariantId;
          if (!input.hasAttribute('data-variant-media') && choice.dataset.cardVariantMedia) input.dataset.variantMedia = choice.dataset.cardVariantMedia;
          if (!input.hasAttribute('data-variant-secondary-media') && choice.dataset.cardVariantSecondaryMedia) input.dataset.variantSecondaryMedia = choice.dataset.cardVariantSecondaryMedia;
        });
        this.addEventListener('change', event => {
          if (!event.target.matches('input[type="radio"]')) return;
          const name = event.target.closest('[data-color-name]')?.dataset.colorName;
          const label = this.querySelector('[data-current-color]');
          if (!name || !label) return;
          label.textContent = name;
          label.title = name;
          const card = this.closest('product-card');
          const variantId = event.target.dataset.variantId;
          const productUrl = event.target.dataset.productUrl;
          if (card && (variantId || productUrl)) {
            const productPath = productUrl || `${window.Shopify.routes.root}products/${card.getAttribute('handle')}`;
            const url = new URL(productPath, location.origin);
            if (variantId) url.searchParams.set('variant', variantId);
            const handle = url.pathname.split('/products/')[1];
            if (handle) {
              card.querySelectorAll('quick-buy-modal').forEach(modal => modal.setAttribute('handle', `${handle}${url.search}`));
            }
            if (variantId) {
              const directAddVariant = card.querySelector('product-form input[name="id"]');
              if (directAddVariant) directAddVariant.value = variantId;
            }
          }
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fh-header-localization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fh-header-localization-content')) {
    customElements.define('fh-header-localization-content', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        const dialog = this.closest('x-modal');
        const form = this.querySelector('form');
        const filter = this.querySelector('[data-country-filter]');
        const status = this.querySelector('[data-country-status]');
        const countryRows = [...this.querySelectorAll('[data-country-name]')];
        const normalize = value => value.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss');
        const updateSummary = () => {
          const country = this.querySelector('[name="country_code"]:checked');
          if (country) this.querySelector('[data-selected-country]').textContent = country.dataset.countrySummary;
        };
        const filterCountries = () => {
          const query = normalize(filter?.value.trim() || '');
          let count = 0;
          countryRows.forEach(row => {
            const matches = normalize(`${row.dataset.countryName} ${row.dataset.countryCode}`).includes(query);
            row.hidden = !matches;
            if (matches) count += 1;
          });
          if (status) status.textContent = count ? '' : this.dataset.emptyMessage;
        };
        filter?.addEventListener('input', filterCountries, { signal });
        form?.addEventListener('change', updateSummary, { signal });
        dialog?.addEventListener('dialog:before-show', () => {
          form.reset();
          if (filter) filter.value = '';
          filterCountries();
          updateSummary();
        }, { signal });
        dialog?.addEventListener('dialog:after-show', () => {
          if (!dialog.contains(document.activeElement)) this.querySelector('[data-localization-close]').focus({ preventScroll: true });
        }, { signal });
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape' || !dialog?.open) return;
          event.preventDefault();
          event.stopPropagation();
          dialog.hide();
        }, { capture: true, signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fh-header-styles"] && !Shopify.designMode) return;
  try {
    if (!window.fhHeaderMenuBound) {
  window.fhHeaderMenuBound = true;
  document.addEventListener('click', event => {
    const summary = event.target.closest('.fh-header .header__primary-nav summary');
    const disclosure = summary?.closest('mega-menu-disclosure');
    if (event.detail > 0 && disclosure?.trigger === 'hover') {
      event.preventDefault();
      event.stopPropagation();
      disclosure.open();
    }
  }, true);
  document.addEventListener('keydown', event => {
    const summary = event.target.closest('.fh-header .header__primary-nav summary');
    if (summary && event.key === 'ArrowDown') {
      event.preventDefault();
      const disclosure = summary.closest('mega-menu-disclosure');
      disclosure?.open();
      summary.nextElementSibling?.querySelector('a')?.focus();
    }
  });
  document.addEventListener('dialog:before-show', event => {
    if (event.target.matches('header-search,#fh-header-localization,header-sidebar')) {
      document.querySelectorAll('.fh-header mega-menu-disclosure').forEach(disclosure => disclosure.close());
    }
  }, true);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fh-lookbook-media"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fh-lookbook-media')) {
    customElements.define('fh-lookbook-media', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        this.addEventListener('click', event => {
          const thumbnail = event.target.closest('[data-look-gallery]');
          if (thumbnail) {
            this.querySelectorAll('[data-look-gallery]').forEach(button => button.setAttribute('aria-pressed', String(button === thumbnail)));
            this.querySelectorAll('[data-look-gallery-panel]').forEach(panel => { panel.hidden = panel.dataset.lookGalleryPanel !== thumbnail.dataset.lookGallery; });
          }
          const dialog = this.querySelector('dialog');
          const zoom = event.target.closest('[data-look-zoom]');
          if (zoom && dialog) {
            this.returnFocus = zoom;
            const photo = zoom.querySelector('img').cloneNode(true);
            photo.loading = 'eager';
            dialog.querySelector('[data-look-enlarged]').replaceChildren(photo);
            dialog.showModal();
          }
          if (event.target.closest('[data-look-close]') || event.target === dialog) dialog?.close();
        }, { signal: this.abort.signal });
        this.querySelector('dialog')?.addEventListener('close', () => { if (this.returnFocus?.isConnected) this.returnFocus.focus(); }, { signal: this.abort.signal });
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fh-header-search-content')) {
    customElements.define('fh-header-search-content', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        const dialog = this.closest('header-search');
        const input = this.querySelector('[name="q"]');
        const idle = this.querySelector('[data-search-idle]');
        const updateIdle = () => { if (idle) idle.hidden = input.value.trim().length > 0; };
        input.addEventListener('input', updateIdle, { signal });
        this.querySelector('form').addEventListener('reset', () => queueMicrotask(updateIdle), { signal });
        dialog.addEventListener('dialog:before-show', () => {
          queueMicrotask(() => { if (dialog.open && this.isConnected) input.focus({ preventScroll: true }); });
          updateIdle();
        }, { signal });
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape' || !dialog.open) return;
          event.preventDefault();
          event.stopPropagation();
          dialog.hide();
        }, { capture: true, signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-sidebar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fh-header-sidebar-controller')) {
    customElements.define('fh-header-sidebar-controller', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        Promise.all([customElements.whenDefined('header-sidebar'), customElements.whenDefined('header-sidebar-collapsible-panel')]).then(() => {
          if (signal.aborted || !this.isConnected) return;
          const sidebar = this.closest('header-sidebar');
          const panel = sidebar.querySelector('header-sidebar-collapsible-panel');
          const main = sidebar.querySelector('.header-sidebar__main-panel');
          const footer = sidebar.querySelector('.header-sidebar__footer');
          const header = sidebar.getShadowPartByName('header');
          const roots = Array.from(main.querySelectorAll('[aria-controls]'));
          let previousPanel;
          panel.focusTrap.updateContainerElements([header, panel, footer]);
          const syncPanel = () => {
            const activeId = panel.getAttribute('aria-activedescendant');
            main.inert = Boolean(activeId);
            roots.forEach(button => button.setAttribute('aria-expanded', String(button.getAttribute('aria-controls') === activeId)));
            if (activeId) {
              const active = document.getElementById(activeId);
              if (active && !active.hidden && previousPanel !== activeId) {
                previousPanel = activeId;
                panel.querySelector('.header-sidebar__scroller').scrollTop = 0;
                requestAnimationFrame(() => {
                  if (!signal.aborted && sidebar.open && panel.getAttribute('aria-activedescendant') === activeId) active.querySelector('[data-fh-category-title]')?.focus({ preventScroll: true });
                });
              }
            } else {
              previousPanel = undefined;
            }
          };
          this.observer = new MutationObserver(syncPanel);
          this.observer.observe(panel, { attributes: true, attributeFilter: ['aria-activedescendant', 'hidden'], subtree: true });
          sidebar.addEventListener('dialog:before-hide', () => {
            main.inert = false;
            panel.removeAttribute('aria-activedescendant');
          }, { signal });
          sidebar.addEventListener('dialog:after-hide', () => { previousPanel = undefined; main.inert = false; }, { signal });
          panel.addEventListener('dialog:before-hide', () => {
            const activeId = panel.getAttribute('aria-activedescendant');
            if (!activeId) return;
            panel.removeAttribute('aria-activedescendant');
            if (sidebar.open) {
              sidebar.revealItems();
              const button = roots.find(root => root.getAttribute('aria-controls') === activeId);
              panel.addEventListener('dialog:after-hide', () => { if (sidebar.open) button?.focus({ preventScroll: true }); }, { once: true, signal });
            }
          }, { signal });
          panel.addEventListener('click', event => {
            if (!event.target.closest('[data-action="close-panel"]')) return;
            const button = roots.find(root => root.getAttribute('aria-controls') === previousPanel);
            panel.addEventListener('dialog:after-hide', () => { if (sidebar.open) button?.focus({ preventScroll: true }); }, { once: true, signal });
          }, { signal });
          const desktop = matchMedia('(min-width: 1100px)');
          desktop.addEventListener('change', () => { if (desktop.matches && sidebar.open) sidebar.hide(); }, { signal });
          syncPanel();
        });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
